import React, { useState } from 'react';
import './UserChatInput.css';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import SendIcon from '@mui/icons-material/Send';

interface IUserChatInputProps {
    onSendMessage: (str: string) => void;
}

const UserChatInput = ({onSendMessage}: IUserChatInputProps) => {
    const [message, setMessage] = useState('');

    const handleInputChange = (e: { target: { value: React.SetStateAction<string>; }; }) => {
        setMessage(e.target.value);
    };

    const handleSendClick = () => {
        if (message.trim() !== '') {
            onSendMessage(message);
            setMessage('');
        }
    };

    const handleKeyPress = (e: { key: string; }) => {
        if (e.key === 'Enter') {
            handleSendClick();
        }
    };

    return (
        <div className={'user-chat-input'}>
            <TextField
                id={'user-chat-input'}
                inputProps={{
                    autoComplete: 'off',
                }}
                label="How can we help?"
                variant="outlined"
                fullWidth
                value={message}
                onChange={handleInputChange}
                onKeyPress={handleKeyPress}
            />
            <IconButton color="primary" onClick={handleSendClick}>
                <SendIcon />
            </IconButton>
        </div>
    );
};

export default UserChatInput;
